import { ArrowUpRight, BookOpen, Sigma } from "lucide-react";
import type React from "react";

const Recommendations: React.FC = () => (
  <>
    <section className="bg-[#2d174d] py-20 text-white">
      <div className="site-shell">
        <p className="eyebrow text-emerald-300">Resources for team practice</p>
        <h1 className="mt-5 max-w-4xl text-5xl font-black tracking-tight sm:text-7xl">
          Prepare for the mathematics that teams solve together.
        </h1>
        <p className="mt-6 max-w-3xl text-xl leading-8 text-violet-100">
          These sources explain the competition and provide years of demanding
          problems written for ARML-style training.
        </p>
      </div>
    </section>

    <section className="site-shell py-20">
      <div className="grid gap-6 md:grid-cols-2">
        <a
          className="story-card group bg-emerald-100 transition hover:-translate-y-1"
          href="https://www.arml.com/"
          target="_blank"
          rel="noreferrer"
        >
          <div className="story-icon bg-emerald-300">
            <Sigma aria-hidden="true" />
          </div>
          <p className="eyebrow mt-8 text-emerald-900">
            Competition information
          </p>
          <h2 className="mt-3 text-3xl font-black">
            The official ARML website
          </h2>
          <p className="mt-4 text-lg leading-8 text-slate-700">
            Read the current contest format, rules, history, locations, and
            announcements from the American Regions Mathematics League.
          </p>
          <span className="story-link">
            Visit ARML
            <ArrowUpRight size={17} aria-hidden="true" />
          </span>
        </a>

        <a
          className="story-card group bg-violet-100 transition hover:-translate-y-1"
          href="https://www.amazon.com/FARML-Practice-Materials-Minnesota-2007-2020/dp/0578745151"
          target="_blank"
          rel="noreferrer"
        >
          <div className="story-icon bg-violet-300">
            <BookOpen aria-hidden="true" />
          </div>
          <p className="eyebrow mt-8 text-violet-900">Fourteen years of work</p>
          <h2 className="mt-3 text-3xl font-black">
            FARML Practice Materials, 2007–2020
          </h2>
          <p className="mt-4 text-lg leading-8 text-slate-700">
            Minnesota ARML coaches assembled complete problems and solutions
            from their training program. The collection emphasizes ideas,
            communication, and the difficulty students should expect from
            serious team practice.
          </p>
          <span className="story-link">
            View the book
            <ArrowUpRight size={17} aria-hidden="true" />
          </span>
        </a>
      </div>
    </section>
  </>
);

export default Recommendations;
